<script>
import apiEndpoints from "@/services/apiEndpoints";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import DatePicker from "vue2-datepicker";
import datetime from "@/mixins/datetime";
import systemCode from "@/mixins/systemCode";
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import selectMultipleCarWithCheckbox from "@/views/pages/project/schedule/mixins/selectMultipleCarWithCheckbox";
import moment from 'moment';

export default {
  mixins: [tableSearch, datetime, systemCode, selectMultipleCarWithCheckbox],
  components: {
    CommonTableComponent,
    DatePicker,
    Multiselect
  },
  data() {
    return {
      isLoading: false,
      dataSelected: [],
      filters: {
        column: "zz_car_types.car_type",
        dir: "DESC",
        start_datetime: '',
        zz_car_types_parent_id: [],
        assigned_staffs: [],
      },
      headers: [
        {
          text: "",
          value: "",
          sortable: false
        },
        {
          text: "車両種類",
          value: "zz_car_types.car_type",
          sortable: false,
          width: 45
        },
        {
          text: "車両",
          value: "car_full_name",
          sortable: false,
          width: 35
        },
      ],
      dateValue: '',
      currentSchedule: {},
      carByType: [],
      countHourHeader: 0,
      timezoneStart: 0,
      timezoneEnd: 0,
    };
  },
  methods: {
    findTimezoneStart() {
      // overwrite the mixin method, fix the value, no need to get the system code
      return {
        system_code_value: 0,
      }
    },
    findTimezoneEnd() {
      // overwrite the mixin method, fix the value, no need to get the system code
      return {
        system_code_value: 24,
      }
    },
    generateHeaderTimes() {
      const timezoneStart = parseInt(this.findTimezoneStart().system_code_value);
      let timezoneEnd = parseInt(this.findTimezoneEnd().system_code_value ?? 23);
      timezoneEnd == 24 && timezoneEnd--;

      this.timezoneStart = timezoneStart
      this.timezoneEnd = timezoneEnd
      this.countHourHeader = timezoneEnd - timezoneStart + 1
      for (let i = timezoneStart; i <= timezoneEnd; i++) {
        this.headers.push({
          text: `${i}時`,
          value: "",
          sortable: false
        })
      }
    },
    async getData() {
      this.isLoading = true;
      const url = apiEndpoints.list_schedule_of_car() // carController.listSchedule
      const {status, data} = await this.$http.get(url, this.filters)

      if (status) {
        this.mappingData(data.result);
      }
      this.isLoading = false;
    },
    updateUrlFilters () {
      this.getData()
    },
    mappingData(cars) {
      const timezoneStart = parseInt(this.findTimezoneStart().system_code_value);
      let timezoneEnd = parseInt(this.findTimezoneEnd().system_code_value ?? 23);
      timezoneEnd == 24 && timezoneEnd--;
      const carsCheckedHours = cars.map(car => ({...car, arrayCheckHour: this.checkHour(car, timezoneStart, timezoneEnd),}));
      this.$set(this.carByType, "", carsCheckedHours);
    },
    updateValue: function () {
      let dataSelectedByLocalData = this.allCars.filter(item => this.dataSelected.includes(item.id))
      let dataSelectedByCurrentSchedule = this.currentSchedule.assigned_cars_by_schedule.filter(car => this.dataSelected.includes(car.id))

      const mergedData = [...dataSelectedByLocalData, ...dataSelectedByCurrentSchedule]
      const dataSelected = [...new Map(mergedData.map(item => [item['id'], item])).values()];

      this.$emit("dataSelected", {
        dataSelected,
        currentSchedule: this.currentSchedule
      });
      this.closeModal();
    },
    removeSelectedData(id) {
      this.dataSelected = this.dataSelected.filter(item => item !== id)
    },
    openModal(schedule) {
      this.filters.start_datetime = this.formatDate(schedule.start_datetime);
      this.filters.assigned_staffs = schedule.assigned_staffs_by_schedule.map(staff => staff.id);
      this.dataSelected = schedule.assigned_cars_by_schedule.map(car => car.id);
      this.currentSchedule = schedule;
      this.$nextTick(() => this.$bvModal.show("modal-schedule-car"));
    },
    closeModal() {
      this.$bvModal.hide("modal-schedule-car");
    },
    checkHour(car, start = 1, end = 24) {
      let arrayCheckHour = new Array(end - start + 1).fill(false);
      car.assigned_cars_by_schedule.forEach(schedule => {
        arrayCheckHour = arrayCheckHour.map((item, index) => {
          let datetime = this.getDateTimeFromDateString(this.filters.start_datetime, index + start)
          return item || (datetime.isSameOrAfter(schedule.start_datetime) && datetime.isBefore(schedule.end_datetime))
        })
      })

      // 直接登録のスケジュールのチェックも行う
      car.car_predetermined_schedules.forEach(schedule => {
        arrayCheckHour = arrayCheckHour.map((item, index) => {
          let datetime = this.getDateTimeFromDateString(this.filters.start_datetime, index + start)
          return item || (datetime.isSameOrAfter(schedule.start_datetime) && datetime.isBefore(schedule.end_datetime))
        })
      });

      return arrayCheckHour
    },
    classHasHour(index, schedule, target = 'f') {
      // schedule という変数名だが実態は car 
      let items = schedule.assigned_cars_by_schedule; // assigned_staffs_by_schedule は該当日のそのcarの予定一覧
      let current = moment(this.filters.start_datetime+ " " +  (index-1  + this.timezoneStart) + ":00:00", "YYYY-MM-DD HH:mm:ss");

      // 他のスケジュールの割り当て　＞　予定登録　＞　Gカレンダーの順にチェックして、
      // 予定が入っているようならその時点でクラスを返して終わり

      for (const item of items) {
        let startDate = moment(item.start_datetime, "YYYY-MM-DD HH:mm:ss");
        let endDate = moment(item.end_datetime, "YYYY-MM-DD HH:mm:ss");

        // チェック中の時間がstartかendと一致している場合「半分塗る」という可能性があるので注意
        //if(current.hour() == startDate.hour()){
        if(current.isSame(startDate, 'hour')){
          //開始時間とチェック時間が一致していて前半チェックの場合、startのminuteが30未満の場合は塗ってよい
          if(target == 'f' && startDate.minute() < 30){
            return 'bg-primary';
          }
          //開始時間とチェック時間が一致していて後半チェックの場合、絶対に塗る
          if(target == 's'){
            return 'bg-primary';
          }
        }

        //if(current.hour() == endDate.hour()){
        if(current.isSame(endDate, 'hour')){
          //終了時間とチェック時間が一致していて前半チェックの場合、00分でなければ塗る
          if(target == 'f' && endDate.minute() != 0){
            return 'bg-primary';
          }
          //終了時間とチェック時間が一致していて後半チェックの場合、30より大きければ塗る
          if(target == 's' && endDate.minute() > 30){
            return 'bg-primary';
          }
        }

        // 開始時間終了時間と一致しない場合は今まで通り
        //if( current.hour() != startDate.hour() && (current.hour() != endDate.hour())){
        if( !current.isSame(startDate, 'hour') && !current.isSame(endDate, 'hour')){
          if (current >= startDate && current < endDate) {
            return 'bg-primary';
          }
        }

      }

      items = schedule.car_predetermined_schedules;

      for (const item2 of items) {
        let startDate = moment(item2.start_datetime, "YYYY-MM-DD HH:mm:ss");
        let endDate = moment(item2.end_datetime, "YYYY-MM-DD HH:mm:ss");

        // チェック中の時間がstartかendと一致している場合「半分塗る」という可能性があるので注意
        //if(current.hour() == startDate.hour()){
        if(current.isSame(startDate, 'hour')){
          //開始時間とチェック時間が一致していて前半チェックの場合、startのminuteが30未満の場合は塗ってよい
          if(target == 'f' && startDate.minute() < 30){
            return 'bg-primary';
          }
          //開始時間とチェック時間が一致していて後半チェックの場合、絶対に塗る
          if(target == 's'){
            return 'bg-primary';
          }
        }

        //if(current.hour() == endDate.hour()){
        if(current.isSame(endDate, 'hour')){
          //終了時間とチェック時間が一致していて前半チェックの場合、00分でなければ塗る
          if(target == 'f' && endDate.minute() != 0){
            return 'bg-primary';
          }
          //終了時間とチェック時間が一致していて後半チェックの場合、30より大きければ塗る
          if(target == 's' && endDate.minute() > 30){
            return 'bg-primary';
          }
        }

        // 開始時間終了時間と一致しない場合は今まで通り
        //if( current.hour() != startDate.hour() && (current.hour() != endDate.hour())){
        if( !current.isSame(startDate, 'hour') && !current.isSame(endDate, 'hour')){
          if (current >= startDate && current < endDate) {
            return 'bg-primary';
          }
        }

      }

      return '';
    },

    onClickRow(car) {
      const isSelectedCar = this.dataSelected.includes(car.id)
      if (isSelectedCar) {
        this.removeSelectedData(car.id)
      } else {
        this.dataSelected.push(car.id)
      }
    },
  },
  computed: {
    ...mapState("options", ["system_codes"]),
    cars() {
      return this.carByType[""] ?? []
    },
    allCars() {
      let cars = [];
      Object.keys(this.carByType).forEach(key => {
        cars = [
          ...cars,
          ...this.carByType[key]
        ]
      })

      return cars;
    }
  },
  watch: {
    system_codes: {
      handler(val) {
        if (val.length) {
          this.generateHeaderTimes()
        }
      },
      immediate: true,
    }
  },
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <slot name="openBtn">

    </slot>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="modal-schedule-car"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-baseline w-100">
          <h5>車両予定一覧</h5>
          <b-button
            size="lg"
            variant="primary"
            @click="closeModal"
          >
            戻る
          </b-button>
        </div>
      </template>
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <b-row class="my-4">
              <b-col align-self="center" cols="1">作業予定日:</b-col>
              <b-col align-self="center">
                <b-form-input
                  v-model="filters.start_datetime"
                  type="text"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col align-self="center" offset="1" cols="2">車両種類（タイプ）:
                <b-col align-self="center" class="multiple-select-custom">
                  <Multiselect
                    :options="zzCarTypesParent"
                    :multiple="true"
                    v-model="selectedCarTypeParent"
                    @input="onChangeCarTypeParent"
                    placeholder=""
                    :close-on-select="false"
                    group-values="attributes"
                    group-label="selectAll"
                    label="car_types_parent"
                    track-by="id"
                    :group-select="true"
                    selectLabel=""
                    selectGroupLabel=""
                    deselectLabel=""
                    deselectGroupLabel=""
                    selectedLabel=""
                  >
                  <template #option="props">
                    <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                      <input type="checkbox" @click.self.prevent="checkCarCheckedAll()" id="car_types_parent_all" :checked="checkCarCheckedAll()">
                      <span class="option__small">{{ props.option.$groupLabel }}</span>
                    </div>
                    <div class="option__desc d-flex align-items-center gap-2" v-else>
                      <input type="checkbox" :id="`car_types_parent_${props.option.id}`" :checked="checkCarChecked(props.option)">
                      <span class="option__small">{{ props.option.car_types_parent }}</span>
                    </div>
                  </template>
                  <template #selection="{ values, search, isOpen }">
                    <span class=""
                          v-if="values.length == 0 || selectedCarTypeParent.length == zzCarTypesParent[0].attributes.length"
                          >車両タイプ: 全て</span>
                    <span class="multiselect__single"
                      v-if="values.length && values.length != zzCarTypesParent[0].attributes.length"
                      >{{ selectedCarTypeParent.map(item => item.car_types_parent).join('、') }}</span>
                  </template>
                </Multiselect>
                </b-col>
              </b-col>
            </b-row>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                  style="padding:0;min-width:35px;text-align: center;"
                >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in cars" class="cursor-pointer" @click="onClickRow(item)">
                <td class="text-center">
                  <b-form-checkbox :value="item.id" v-model="dataSelected"/>
                </td>
                <td>
                  <span v-if="item.zz_car_type">{{ item.zz_car_type.car_type }}</span>
                </td>
                <td>
                  {{item.car_full_name}}
                </td>
                <td class="cell-custom" v-for="indexAssign in countHourHeader" :key="indexAssign" :class="classHasHour(indexAssign, item) == '' ? 'border-hour' : ''">
                    <div style="display: flex;width: 100%;">
                      <div :id="indexAssign" :class="classHasHour(indexAssign, item, 'f')" class="min-w-100"></div>
                      <div :id="indexAssign" :class="classHasHour(indexAssign, item, 's')" class="min-w-100"></div>
                    </div>
                  </td>              </tr>
              <tr v-if="!cars.length">
                <td colspan="15" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <b-button
              size="lg"
              variant="primary"
              @click="updateValue"
            >
              確定
            </b-button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
table tr .cell-custom {
  padding: 0;
  border: 0;
  width: 30px;

  div {
    min-height: 20px;
  }
}


.min-w-100{
  display: inline-block;
  width: 100%;
}


.border-hour {
  border: 1px solid #ced4da!important;
}
</style>
